import React, { useState } from 'react';
import styles from './AddCategoryModal.module.css';

const AddCategoryModal = ({ isOpen, onClose, onCreate }) => {
  const [categoryName, setCategoryName] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryName.trim()) return;
    
    await onCreate(categoryName.trim());
    setCategoryName('');
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.modalContent}>
        <h3>Add New Category</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Enter category name..."
            autoFocus
            className={styles.input}
          />
          <div className={styles.buttonGroup}>
            <button type="submit" className={styles.addButton}>
              Add Category
            </button>
            <button type="button" onClick={onClose} className={styles.cancelButton}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategoryModal;